module.exports = __webpack_public_path__ + "img/gallery11.93bb260.jpg";